import { AuthenService } from "@/services/authen.service.ts";
import { CommonService } from "@/services/Common.service";
import { OsusumeSeibiItem } from "@/models/OsusumeSeibi";

export class OsusumeSeibiService {
  private baseAPI = process.env.VUE_APP_API_URL;
  private commonAPI = process.env.VUE_APP_API_COMMON_URL;
  private authService = new AuthenService();
  private commonService = new CommonService();

  constructor() {}

  get headers() {
    return {
      "Content-Type": "application/json",
      auth: localStorage.getItem("token")
    };
  }

  public async getKyotens() {
    return this.commonService.getKyotens();
  }

  public async getOsusumeSeibi() {
    const { result, error } = await this.commonService.get(`${this.baseAPI}/admin/seibi-osusume`);
    if (result) {
      return result.data;
    } else {
      this.authService.handleError(error, "getOsusumeSeibi");
      return;
    }
  }

  public async addOsusumeSeibi(data: OsusumeSeibiItem) {
    const { result, error } = await this.commonService.post(`${this.baseAPI}/admin/seibi-osusume`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, "handleError");
      return;
    }
  }

  public async editOsusumeSeibi(data: OsusumeSeibiItem) {
    const { result, error } = await this.commonService.put(`${this.baseAPI}/admin/seibi-osusume`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, "editOsusumeSeibi");
      return;
    }
  }

  public async deleteOsusumeSeibi(data: OsusumeSeibiItem) {
    const { result, error } = await this.commonService.delete(`${this.baseAPI}/admin/seibi-osusume`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, "deleteOsusumeSeibi");
      return;
    }
  }

  public async reorderOsusumeSeibi(data: OsusumeSeibiItem[]) {
    const { result, error } = await this.commonService.put(`${this.baseAPI}/admin/seibi-osusume/order`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, "reorderOsusumeSeibi");
      return;
    }
  }

  public async getSeibiRecommendSeibi() {
      let path = `${this.baseAPI}/admin/seibi-recommend-seibi`;
      const { result, error } = await this.commonService.get(`${this.baseAPI}/admin/seibi-recommend-seibi`);
      if (result) {
          return result.data;
      } else {
          this.authService.handleError(error, 'getSeibiRecommendSeibi');
          return;
      }
  }

  public getRecommendExtremeWorks() {
    return this.commonService.get(`${this.baseAPI}/admin/osusume/exp-works`);
  }

  // 2022-01-31 morisako kobac-free add [START]
  public async getSeibiRecommendSeibiBySknInspectSeibiFeeId(sknInspectSeibiFeeId: number) {
      let path = `${this.baseAPI}/admin/seibi-recommend-seibi/` + sknInspectSeibiFeeId;
      const { result, error } = await this.commonService.get(path);
      if (result) {
          return result.data;
      } else {
          this.authService.handleError(error, 'getSeibiRecommendSeibiBySknInspectSeibiFeeId');
          return;
      }
  }
  async getInspectMenuFee() {
    const path  = `${this.baseAPI}/admin/recommend-inspect-seibi-fee-table`;
    const { result, error } = await this.commonService.get(path);
    if (result && result.status === 200) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getInspectMenuFee');
      return [];
    }
  }
  // 2022-01-31 morisako kobac-free add [END]
}
